export enum DualListSeelctorDirectionsEnum {
  Left = 1,
  Right = 2
}
